import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

// Toolbar
export const getEditorWithBarToolbarSx = (theme: Theme): SystemStyleObject => ({
  zIndex: 1,
  borderRadius: '8px 8px 0 0',
  border: `1px solid ${theme.palette.action.hover}`,
  '&.MuiToolbar-root': {
    minWidth: 'auto',
    overflow: 'auto', // Scroll this bar for now until if not enough space - fix on: CMSADMIN-168
    '& .MuiSvgIcon-root': {
      fontSize: '1.5em', // Sets button size
      height: 'auto',
    },
    height: 'min-content',
    backgroundColor: theme.palette.action.hover,
    '&:focus-within': {
      backgroundColor: theme.palette.action.hover,
    },
    padding: 0,
    minHeight: 'auto',
    '& button': {
      height: 35,
      borderColor: 'transparent',
      color:
        theme.palette.mode === 'light'
          ? theme.blox.colors.darkgray
          : theme.blox.colors.offwhite,
      '&:disabled': {
        color: theme.palette.grey[400],
      },
    },
  },
});

// Input
// The && here is to trick and increase specificity in Emotion/MUI
// as some parent styles from editorial container also targeting ProseMirror
// were being applied and causing double outlines while input was focused...
// but note EditorWithBar is also used elsewhere in the app, not just editorial
export const getEditorWithBarInputSx = (theme: Theme): SystemStyleObject => ({
  '&& .input-field .tiptap.ProseMirror': {
    backgroundColor: theme.palette.background.paper,
    wordBreak: 'break-word',
    margin: '0px',
    borderTopLeftRadius: '0',
    borderTopRightRadius: '0',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    padding: '8px',
    width: '100%',
    minHeight: '60px',
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    // rm margin between tags inside rich input for proper linebreak style
    '& *': {
      margin: 0,
    },
    '&:hover': {
      cursor: 'text',
    },
    '&:focus-within': {
      outline: 'none',
      border: 'none',
      boxShadow: 'none',
    },
  },
  // Error state styling
  '&& .input-field.has-error .tiptap.ProseMirror': {
    borderBottom: `2px solid ${theme.palette.error.main}`,
  },
});

// Wrapper
export const getEditorWithBarWrapperSx = (theme: Theme): SystemStyleObject => ({
  mt: 1,
  borderRadius: '8px',
  outline: `2px solid ${theme.palette.action.hover}`,
  '&:hover:not(:focus-within)': {
    outline: `2px solid ${theme.palette.action.focus}`,
  },
  '&:focus-within': {
    outline: `2px solid ${theme.palette.primary.main}`,
  },
  // Error text and icon below input field
  '& .error-notice': {
    color: theme.palette.error.main,
    bgcolor: theme.palette.action.hover,
    display: 'flex',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    alignItems: 'center',
    gap: '4px',
    padding: '4px',
    width: '100%',
    '& svg': {
      fontSize: '16px',
    },
    '& .error-text': {
      fontSize: '16px',
    },
  },
});
